// extracted by mini-css-extract-plugin
export default {"indicator":"PreviewPagination_indicator__bbcHz","circle":"PreviewPagination_circle__zOiVI","active":"PreviewPagination_active__RAZHG"};